export function apiUrl (baseDomain, shopId, path) {
  const normalizedPath = path.replace(/^\//, '')
  return 'https://' + baseDomain + '/' + shopId + '/' + normalizedPath
}

export function authFetch (baseDomain, shopId, path, apiKey, options = {}) {
  const headers = new Headers(options.headers || {})
  headers.set('Authorization', 'Bearer ' + apiKey)
  return fetch(apiUrl(baseDomain, shopId, path), Object.assign({}, options, { headers }))
}



// WEBPACK FOOTER //
// ./src/lib/api.js